var exports = {
  "AS": "item__rruuKe",
  "Kk": "icon__lClXIt",
  "R_": "heading__f5SDdZ",
};

module.exports = exports;
